import { FlightNotFoundError } from '@/lib/errors/meta/flight-not-found-error'
import { MetaError } from '@/lib/errors/meta/meta-error'
import { v4 as uuid } from 'uuid'

export class ServiceError extends MetaError {
  static from(
    error: unknown,
    metadata?: Record<string, unknown>,
    message?: string
  ): ServiceError | FlightNotFoundError {
    if (error instanceof FlightNotFoundError) {
      return new FlightNotFoundError(
        metadata,
        message ?? (error instanceof Error ? error.message : undefined)
      )
    }
    return new ServiceError(
      error,
      metadata,
      message ?? (error instanceof Error ? error.message : undefined)
    )
  }

  id: string

  constructor(error: unknown, metadata?: Record<string, unknown>, message?: string) {
    super(error, metadata, message)
    this.id = uuid()
  }
}
